import {lazy} from 'react'
import {Route, Switch} from 'react-router-dom'
import {Container} from '../../modules/components'

export enum FinancialRoutesEnum {
    DatatableStatements = '/financeiro/extrato',
    DatatableClosures = '/financeiro/fechamentos',
    ShowClosure = '/financeiro/fechamentos/:id',
    DatatableOrders = '/financeiro/pedidos',
    ShowOrder = '/financeiro/pedidos/:id',
}

export default function FinancialRouter() {
    const DatatableStatements = lazy(() => import('../../pages/statements/DatatableStatements'))

    const DatatableClosures = lazy(() => import('../../pages/closures/DatatableClosures'))
    const DatatableOrders = lazy(() => import('../../pages/orders/DatatableOrders'))
    const ShowOrder = lazy(() => import('../../pages/orders/ShowOrder'))

    const ShowClosure = lazy(() => import('../../pages/closures/ShowClosure'))

    return (
        <Container loading={false}>
            <Switch>
                <Route
                    path={FinancialRoutesEnum.DatatableStatements}
                    component={DatatableStatements}
                />
                <Route path={FinancialRoutesEnum.ShowOrder} component={ShowOrder} />
                <Route path={FinancialRoutesEnum.DatatableOrders} component={DatatableOrders} />
                <Route path={FinancialRoutesEnum.ShowClosure} component={ShowClosure} />
                <Route path={FinancialRoutesEnum.DatatableClosures} component={DatatableClosures} />
            </Switch>
        </Container>
    )
}
